import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '@standardnotes/snjs';
import Tab from './Tab';
import TabList from './TabList';
const TabsContainer = ({ tabs, state, className, children }) => {
    return (_jsxs("div", { className: classNames('overflow-hidden rounded-md border border-border', className), children: [_jsx(TabList, { state: state, className: "border-b border-border", children: tabs.map(({ id, title }) => (_jsx(Tab, { id: id, className: "first:rounded-tl-md", children: title }, id))) }), children] }));
};
export default TabsContainer;
